import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import GradientButton from "../../components/button/Button";
import "./Success.css";

const Success: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("cart");
    const timer = setTimeout(() => {
      navigate("/retail-orders");
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="success-page">
      <div className="success-page__icon">
        {/* Success checkmark SVG */}
        <svg width="70" height="70" viewBox="0 0 70 70" fill="none">
          <circle cx="35" cy="35" r="35" fill="#4caf50" />
          <path
            d="M20 36L32 48L50 28"
            stroke="#fff"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <h1 className="success-page__title">Payment was successful</h1>
      <p className="success-page__desc">
        Thank you for your payment! Your transaction has been completed
        successfully. You can view your orders anytime.
      </p>
      <div className="success-page__btn">
        <GradientButton
          text="Back to Orders"
          onClick={() => navigate("/retail-orders")}
        />
      </div>
    </div>
  );
};

export default Success;
